import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./App.css";
import 'bootstrap/dist/css/bootstrap.css';
import "./styles/scss/index.scss";
import { Provider } from 'react-redux';
import store from './redux/store';
import { ThemeProvider, ThemedApp } from './components/standalone/ThemeProvider';
import "./i18n"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <ThemeProvider>
        <ThemedApp>
          <App />
        </ThemedApp>
      </ThemeProvider>
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
